// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Drawer_wrapper__3BYPO","header":"Drawer_header__vNXus","icon":"Drawer_icon__11eyg"};